import react, { useEffect, useMemo, useState } from "react";
import { Checkbox, STYLE_TYPE } from "baseui/checkbox";
import { colors, fonts } from "../../Styles";

interface Toggle_Props {
  isChecked?: boolean,
  isDisabled?: boolean
  label?: string
  icon: JSX.Element
  onChange?: (e:boolean) => void;
}
/**
 * Toggle
 * @param label text to display before the actual button.
 * @param icon icon to display inside the toggle switch.
 * @param onToggle function to run when checked=true.
 * @returns a BaseUi checkbox with checkmarkType=toggle, build from content param. 
 */
export default function Toggle({isChecked, isDisabled, label, icon, onChange}:Toggle_Props) {
  // const [checked, setChecked] = useState(isChecked?isChecked:false);
  const [checked, setChecked] = useState(isChecked || false);

  useEffect(() => {
    setChecked(isChecked || false);
  }, [isChecked]);

  const handleChange = (newChecked: boolean) => {
    setChecked(newChecked);
    if (onChange) {
      onChange(newChecked);
    }
  };

  return (
    <div style={{display: "flex", flexDirection: "row-reverse", alignItems: "center", gap: "10px"}}>
    <div style={{position: "relative"}}>
      <div>
        <Checkbox
          checked={checked}
          onChange={(e) => handleChange(e.target.checked)}
          disabled={isDisabled}
          checkmarkType={STYLE_TYPE.toggle}
          overrides={{
            Root: { style: () => Object.assign({}, {
              opacity: isDisabled? "0.3" : "1",
              // alignItems: "center",
              // width: "fit-content"
              zIndex: "10"
            } as React.CSSProperties )},
            Toggle: { style: () => Object.assign({}, {
              height: "23px",
              width: "23px",
              backgroundColor: colors.greySecondary,
              // backgroundImage: `url(${icon})`,
              backgroundSize: "16px",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              transform: !checked ? "rotate(-180deg)" : "translateX(23px)", 
              transition: "0.5s ease-in-out",
              boxShadow: "none",
            } as React.CSSProperties )},
            ToggleTrack: { style: () => Object.assign({}, {
              backgroundColor: !checked ? colors.systemRed : colors.systemGreen,
              height: "23px",
              width: "46px",
              margin: "0px",
              borderRadius: "20px",
              border: "2px solid",
              borderColor: !checked ? colors.systemRed : colors.systemGreen,
              outline: "2px solid",
              outlineColor: colors.greySecondary,
            } as React.CSSProperties )},
          }}
        />
      </div>
      <div style={{
        position: "absolute", 
        top: "50%", 
        left: "13px", 
        transform: !checked ? "translate(-50%, -50%) rotate(0deg)" : "translate(85%, -50%) rotate(180deg)",
        transition: "0.5s ease-in-out",
        cursor: "pointer",
        width: "17px",
        height: "17px"
      }}
      onClick={() => {
        if (!isDisabled) {
          handleChange(!checked);
        }
      }}
      >
        {icon}
      </div>
    </div>
    {label
      ? <p style={{zIndex: "5", ...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, opacity: isDisabled? "0.3" : "1"}}>{label}</p>
      : undefined
    }
    </div>
  );
}